import React from 'react';
import useOrganizationGroups from '../../../../../hooks/api/useOrganizationGroups';
import { OrganizationTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { RouteProp } from '@react-navigation/native';
import GroupDetails from '../../../../shared/Groups/GroupDetails';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';

export type GroupScreenOwnProps = {};

export type GroupScreenProps = GroupScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'group'>;
};

const GroupScreen: React.FC<GroupScreenProps> = (props) => {
    const goBack = useGoBack();
    const { group, isLoadingGroup } = useOrganizationGroups({
        onUpdateGroupSuccess: goBack,
        groupId: props.route.params.groupId,
    });
    return (
        <AnimateLoadedContent isLoading={isLoadingGroup || !group}>
            {() => (
                <ActionButtonLayout scrollable>
                    <MainContentContainer>
                        <GroupDetails group={group!} />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(GroupScreen);
